import { render, staticRenderFns } from "./VisitRegistry.vue?vue&type=template&id=32cf25dd&scoped=true"
import script from "./VisitRegistry.vue?vue&type=script&lang=js"
export * from "./VisitRegistry.vue?vue&type=script&lang=js"
import style0 from "./VisitRegistry.vue?vue&type=style&index=0&id=32cf25dd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cf25dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32cf25dd')) {
      api.createRecord('32cf25dd', component.options)
    } else {
      api.reload('32cf25dd', component.options)
    }
    module.hot.accept("./VisitRegistry.vue?vue&type=template&id=32cf25dd&scoped=true", function () {
      api.rerender('32cf25dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/visitRegistry/VisitRegistry.vue"
export default component.exports